import React from 'react'
import {ScrollFadeContainer} from '../../common/ScrollFadeContainer/index.ts'
import {MoreMenuGroup} from './MoreMenuGroup/index.ts'
import {MoreMenuItem} from './MoreMenuItem/index.ts'
import {SocialLinks} from './SocialLinks/index.ts'
import {LiveStats} from '../../common/LiveStats/index.ts'
import styles from './MorePage.module.scss'
import IconSettings from '@static/images/icon_settings.svg'
import IconLanguage from '@static/images/icon_language.svg'
import IconBook from '@static/images/icon_book.svg'
import IconQuestionMark from '@static/images/icon_question_mark.svg'
import IconLogoWhite from '@static/images/logo_white.svg'
import IconPlayerHub from '@static/images/icon_player_hub.svg'
import IconBlog from '@static/images/icon_blog.svg'
import IconInfo from '@static/images/icon_info.svg'
import IconCareers from '@static/images/icon_careers.svg'
import IconPrivacy from '@static/images/icon_privacy.svg'
import {useUIGlobalContext} from '@colonist/ui'

export interface MorePageProps {
    showCareersNotification: boolean
    onPatchNotesClick: () => void
    onLanguageClick: () => void
    onRulebookClick: () => void
    isFaqExternal: boolean
    onFaqClick: () => void
    onChampionshipClick: () => void
    onPlayerHubClick: () => void
    onBlogClick: () => void
    onAboutClick: () => void
    onCareersClick: () => void
    onPrivacyClick: () => void
}

export const MorePage = ({
    showCareersNotification,
    onPatchNotesClick,
    onLanguageClick,
    onRulebookClick,
    isFaqExternal,
    onFaqClick,
    onChampionshipClick,
    onPlayerHubClick,
    onBlogClick,
    onAboutClick,
    onCareersClick,
    onPrivacyClick,
}: MorePageProps) => {
    const {versionNumber, language} = useUIGlobalContext()

    return (
        <ScrollFadeContainer fadeTop fadeBottom>
            <div className={styles.content}>
                <div className={styles.leftColumn}>
                    <MoreMenuGroup headerText={{key: 'strings:morePage.game.title'}}>
                        <MoreMenuItem
                            icon={IconSettings}
                            label={{key: 'strings:morePage.game.patchNotes'}}
                            rightText={`v${versionNumber.toString()}`}
                            onClick={onPatchNotesClick}
                        />
                        <MoreMenuItem
                            icon={IconLanguage}
                            label={{key: 'strings:morePage.game.language'}}
                            rightText={language.toUpperCase()}
                            onClick={onLanguageClick}
                        />
                        <MoreMenuItem
                            icon={IconBook}
                            label={{key: 'strings:homePage.header.rules'}}
                            onClick={onRulebookClick}
                        />
                        <MoreMenuItem
                            icon={IconQuestionMark}
                            label={{key: 'strings:homePage.footer.faq'}}
                            rightIcon={isFaqExternal ? 'outArrow' : 'chevron'}
                            onClick={onFaqClick}
                        />
                    </MoreMenuGroup>

                    <MoreMenuGroup headerText={{key: 'strings:morePage.community.title'}}>
                        <MoreMenuItem
                            icon={IconLogoWhite}
                            label={{key: 'strings:morePage.community.championship26'}}
                            onClick={onChampionshipClick}
                        />
                        <MoreMenuItem
                            icon={IconPlayerHub}
                            label={{key: 'strings:morePage.community.playerHub'}}
                            onClick={onPlayerHubClick}
                        />
                        <MoreMenuItem
                            icon={IconBlog}
                            label={{key: 'strings:morePage.community.blog'}}
                            rightIcon="outArrow"
                            onClick={onBlogClick}
                        />
                    </MoreMenuGroup>

                    <MoreMenuGroup headerText={{key: 'strings:morePage.company.title'}}>
                        <MoreMenuItem
                            icon={IconInfo}
                            label={{key: 'strings:morePage.company.about'}}
                            onClick={onAboutClick}
                        />
                        <MoreMenuItem
                            icon={IconCareers}
                            showNotificationIcon={showCareersNotification}
                            label={{key: 'strings:morePage.company.careers'}}
                            onClick={onCareersClick}
                        />
                        <MoreMenuItem
                            icon={IconPrivacy}
                            label={{key: 'strings:morePage.company.privacy'}}
                            onClick={onPrivacyClick}
                        />
                    </MoreMenuGroup>
                </div>

                <div className={styles.rightColumn}>
                    <SocialLinks />

                    <LiveStats />
                </div>
            </div>
        </ScrollFadeContainer>
    )
}
